import SizeGuide from './SizeGuide';

export default SizeGuide;
